﻿import React, { useContext, useEffect } from "react";
import { WaitingListFlowContext } from "../WaitingListFlowContext";
import { shouldAccountBeUpdated } from "../../../../../Resources/Scripts/_Shared/helpers";
import { isWaitingListAttachmentsEnabled } from "../util";

export const BackNavigation = ({ disabled = false, type }) => {
    const { waitingListFlowContext, setWaitingListFlowContext } = useContext(
        WaitingListFlowContext
    );

    const clickHandler = () => {
        const activeStep = ReturnPreviousStep(waitingListFlowContext);
        setWaitingListFlowContext({ ...waitingListFlowContext, activeStep });
        if (
            !waitingListFlowContext.episerver.hasWebticketAccount &&
            activeStep ===
                waitingListFlowContext.paymentTerm.index
        )
            location.reload();
    };

    return type === "CTA" ? (
        <button
            className="single-step__button single-step__button--next"
            disabled={disabled}
            onClick={clickHandler}
        >
            {waitingListFlowContext.localization.global.buttons.previousStep}
        </button>
    ) : (
        <button
            className="waitinglistflowpage__back"
            disabled={disabled}
            onClick={clickHandler}
        >
            {waitingListFlowContext.localization.global.buttons.previousStep}
        </button>
    );
};

export const ReturnPreviousStep = (waitingListFlowContext) => {
    if (
        waitingListFlowContext.activeStep ===
        waitingListFlowContext.paymentTerm.index
    ) {
        //Introduction
        return waitingListFlowContext.introduction.index;
    } else if (
        waitingListFlowContext.activeStep ===
        waitingListFlowContext.login.index
    ) {
        //Login selection
        return waitingListFlowContext.paymentTerm.index;
    } else if (
        waitingListFlowContext.activeStep ===
        waitingListFlowContext.createAccount.index
    ) {
        //Create account
        // if (waitingListFlowContext.user || waitingListFlowContext.episerver.loggedIn)
        return waitingListFlowContext.paymentTerm.index;
        // else
        // return waitingListFlowContext.availableSteps.login.index;
    } else if (
        waitingListFlowContext.activeStep ===
        waitingListFlowContext.vehicle.index
    ) {
        //Add vehicle
        // if(waitingListFlowContext.user) {
        return waitingListFlowContext.paymentTerm.index;
        // }
        // else {
        //   return waitingListFlowContext.availableSteps.login.index;
        // }
    } else if(
        waitingListFlowContext.activeStep ===
        waitingListFlowContext.document.index
    ) {
        //Document Upload
        return waitingListFlowContext.vehicle.index;
    } else if (
        waitingListFlowContext.activeStep ===
        waitingListFlowContext.overview.index
    ) {
        //Order overview
        return isWaitingListAttachmentsEnabled(waitingListFlowContext)
            ? waitingListFlowContext.document.index
            : waitingListFlowContext.vehicle.index;
    }
};
